// src/components/orders/OrdersFilterBar.js
import React, { useState, useEffect } from "react";

/**
 * OrdersFilterBar
 * API identica alle versioni precedenti
 */
export default function OrdersFilterBar({
  restaurantsList,
  selectedRestaurant,
  onChangeRestaurant,
  onFilter,

  showDateFilters = true,
  startDate = "",
  endDate = "",
  onChangeStart = () => {},
  onChangeEnd = () => {},
}) {
  /* --- viewport < 768px --- */
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  /* --- open / close (mobile) --- */
  const [open, setOpen] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onFilter?.();
    if (isMobile) setOpen(false);
  };

  /* ====================== RENDER ====================== */
  return (
    <form onSubmit={handleSubmit} style={st.wrapper}>
      {/* ☰  (mobile, closed) */}
      {isMobile && !open && (
        <button
          type="button"
          aria-label="Apri filtri"
          onClick={() => setOpen(true)}
          style={st.hamburger}
        >
          ☰
        </button>
      )}

      {/* ✕  (mobile, open) */}
      {isMobile && open && (
        <button
          type="button"
          aria-label="Chiudi filtri"
          onClick={() => setOpen(false)}
          style={st.closeBtn}
        >
          ✕
        </button>
      )}

      {/* Contenitore filtri */}
      <div
        style={{
          ...(isMobile ? st.mobileContainer : st.desktopContainer),
          ...(isMobile && !open ? st.hidden : {}),
        }}
      >
        {/* --- Ristorante --- */}
        <FormField label="Ristorante" mobile={isMobile}>
          <select
            style={isMobile ? st.inputMobile : st.input}
            value={selectedRestaurant}
            onChange={(e) => onChangeRestaurant(e.target.value)}
          >
            <option value="all">Tutti</option>
            {restaurantsList.map((r) => (
              <option key={r.id} value={r.id}>
                {r.name}
              </option>
            ))}
          </select>
        </FormField>

        {/* --- Date range (solo Storico) --- */}
        {showDateFilters && (
          <>
            <FormField label="Inizio" mobile={isMobile}>
              <input
                type="date"
                style={isMobile ? st.inputMobile : st.input}
                value={startDate}
                onChange={(e) => onChangeStart(e.target.value)}
              />
            </FormField>
            <FormField label="Fine" mobile={isMobile}>
              <input
                type="date"
                style={isMobile ? st.inputMobile : st.input}
                value={endDate}
                onChange={(e) => onChangeEnd(e.target.value)}
              />
            </FormField>
          </>
        )}

        {/* --- Pulsante Applica --- */}
        <button
          type="submit"
          style={isMobile ? st.applyBtnMobile : st.applyBtn}
        >
          Applica
        </button>
      </div>
    </form>
  );
}

/* -------------------------------------------------------------
   Sottocomponente per label + campo
------------------------------------------------------------- */
function FormField({ label, children, mobile }) {
  return (
    <div style={mobile ? st.fieldMobile : st.field}>
      <label style={st.label}>{label}</label>
      {children}
    </div>
  );
}

/* ============================================================
   STILI
============================================================ */
const pillBase = {
  borderRadius: 40,
  padding: "0.55rem 1.1rem",
  fontSize: "0.9rem",
  outline: "none",
  transition: "border-color 0.2s, background 0.2s",
  border: "1px solid #B0B0B0",
  background: "#F2F2F2",
  color: "#333",
  boxSizing: "border-box",
  maxWidth: "100%",
};

const st = {
  /* wrapper: evita overflow */
  wrapper: {
    background: "#FFFFFF",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    borderRadius: 18,
    padding: "0.75rem 1rem",
    marginBottom: "1rem",
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    position: "relative",
    overflow: "hidden",
    boxSizing: "border-box",
  },

  /* ☰ */
  hamburger: {
    background: "transparent",
    border: "none",
    fontSize: 26,
    cursor: "pointer",
    lineHeight: 1,
  },

  /* ✕  (posizionato in alto-destra) */
  closeBtn: {
    position: "absolute",
    top: 10,
    right: 12,
    background: "transparent",
    border: "none",
    fontSize: 26,
    cursor: "pointer",
    lineHeight: 1,
  },

  /* Desktop container */
  desktopContainer: {
    display: "flex",
    alignItems: "flex-end",
    gap: "1rem",
    flexWrap: "wrap",
    width: "100%",
  },

  /* Mobile container */
  mobileContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
    width: "100%",
    marginTop: "0.5rem",
  },

  hidden: { display: "none" },

  /* campi */
  field: { display: "flex", flexDirection: "column", gap: 4 },
  fieldMobile: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    width: "100%",
  },

  label: { fontSize: "0.75rem", fontWeight: 600, color: "#444" },

  input: { ...pillBase, minWidth: 150 },
  inputMobile: { ...pillBase, width: "100%" },

  /* pulsante Applica */
  applyBtn: {
    ...pillBase,
    border: "none",
    background: "#FF6600",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
    minWidth: 110,
  },
  applyBtnMobile: {
    ...pillBase,
    border: "none",
    background: "#FF6600",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
    width: "100%",
    textAlign: "center",
  },
};
